import { request, Response } from '../utils';
import { Session } from '../types';

export const deleteGraph = (body: {
  session: Session;
  graphID: string;
}): Response<null> => request('delete-graph', body);
